export default ({request}) => ({
  mrpPackagePlanListApi(data = {}) {
    return request({
      url: '/factory/mrp/package/plan/list',
      method: 'post',
      data,
    })
  },
  mrpPackagePlanDetailApi(data = {}) {
    return request({
      url: '/factory/mrp/package/plan/detail',
      method: 'post',
      data,
    })
  },
  mrpPackagePlanDetailListApi(data = {}) {
    return request({
      url: '/factory/mrp/package/plan/detail/list',
      method: 'post',
      data,
    })
  },
  mrpPackagePlanScheduleListApi(data = {}) {
    return request({
      url: '/factory/mrp/package/plan/schedule/list',
      method: 'post',
      data,
    })
  },
})
